var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error503"},[_c('banner',{attrs:{"back-image":_vm.bannerImage,"image":_vm.logo,"title":_vm.$t('error503.title'),"subtitle":_vm.$t('error503.subtitle'),"height":"600"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }